module.exports = __webpack_public_path__ + "img/ba31894.jpg";